module.exports = __webpack_public_path__ + "01_veryshort_gray.ea4e336e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_veryshort_gray.png
// module id = wWsn
// module chunks = 0